module.exports = __webpack_public_path__ + "fonts/download.44864b91.ttf";